/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountStakingEventsRequest
 */
export interface AccountStakingEventsRequest {
    /**
     * 
     * @type {string}
     * @memberof AccountStakingEventsRequest
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof AccountStakingEventsRequest
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStakingEventsRequest
     */
    size: number;
}

export function AccountStakingEventsRequestFromJSON(json: any): AccountStakingEventsRequest {
    return AccountStakingEventsRequestFromJSONTyped(json, false);
}

export function AccountStakingEventsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountStakingEventsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'page': json['page'],
        'size': json['size'],
    };
}

export function AccountStakingEventsRequestToJSON(value?: AccountStakingEventsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'page': value.page,
        'size': value.size,
    };
}


